module.exports = __webpack_public_path__ + "images/In_Store.svg";